<template>
  <PageContainer title="Salas">
    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box v-else space="medium" class="salas-container">
      <Form @submit.prevent="handleSubmit" class="main-form">
        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Autoescola"
              placeholder="Selecione uma autoescola" :modelValue="schema"
              @update:modelValue="$event => schema = $event" />

            <div class="buttons">
              <Button type="submit" text="Atualizar Turmas" color="secondary">
                <Cached />
              </Button>
            </div>
          </div>
        </div>
      </Form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div v-else-if="salas.length > 0 && !loading" class="table-container">
        <Table :headers="['#', 'Sala', 'Capacidade']">
          <tr v-for="sala in salas" :key="sala.id_sala_detran">
            <td>{{ sala.id_sala_detran }}</td>
            <td>{{ sala.sala }}</td>
            <td>{{ sala.capacidade }}</td>
          </tr>
        </Table>
      </div>
    </Box>
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Button from 'core/Button'
import Table from 'core/Table'
import Cached from 'icons/Cached'

export default {
  name: 'ListarSalasVirtuais',
  components: {
    PageContainer,
    Box,
    LoadingSpinner,
    Select,
    Button,
    Table,

    Cached,
  },
  data() {
    return {
      schema: '',
      schemaOptions: [],
      salas: [],
      loading: false,
      loaded: false,
    }
  },
  async created() {
    await this.fetchCfcs()

    this.loaded = true
  },
  methods: {
    async fetchCfcs() {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola`)
        .then((res) => {
          this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
        })
        .catch((error) => {
          this.$toasted.show('Erro:' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async handleSubmit() {
      if (!this.schema) {
        this.$toasted.show('Selecione uma autoescola!', {
          position: 'top-right',
        })

        return
      }

      await this.updateClasses()
    },
    async fetchSalas() {
      const params = {
        schema: this.schema,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/sala`, {
        params,
      })
        .then(res => {
          const response = res.body.dados

          this.salas = response
        })
        .catch(err => {
          this.$toasted.show('Erro ao buscar salas!', {
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async updateClasses() {
      this.loading = true

      const params = {
        schema: this.schema,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/getran/atualizar/salas`, {
        params,
      })
        .then(async res => {
          await this.fetchSalas()
        })
        .catch(err => {
          this.$toasted.show('Erro ao atualizar turmas!', {
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.salas-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;

  .main-form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .pagination-container {
      align-self: flex-end;
    }

    .table-container {
      .actions {
        display: flex;
        align-items: center;

        div {
          padding: 0 0.5rem;
          display: flex;
          justify-content: center;

          &:not(:first-child) {
            border-left: 1px solid #ECECEC;
          }

          &:not(:last-child) {
            border-right: 1px solid #ECECEC;
          }
        }
      }
    }
  }
}
</style>
